import React from 'react';
import { twMerge } from 'tailwind-merge';

import { ChevronLeft as ChevronLeftIcon } from '@videoblocks/react-icons';

const closeSideMenuButtonNew = ({ isOpen, closeSideMenu }) => {
  if (!isOpen) {
    return null;
  }
  return (
    <button
      className="toggleContainer-menuButton mt-0"
      aria-label="Close Side Menu"
      onClick={closeSideMenu}
    >
      <ChevronLeftIcon className="w-3 h-3 m-1.5" />
    </button>
  );
};

type Props = {
  isOpen: boolean;
  closeSideMenu: () => void;
  showSideMenu: () => void;
  clearFilters: React.EventHandler<React.MouseEvent | React.KeyboardEvent>;
};

export default function ClearFilters({
  isOpen,
  closeSideMenu,
  showSideMenu,
  clearFilters,
}: Props) {
  const clearFilterClass = twMerge(
    'flex justify-between items-center h-20 pr-2 pl-4 border-t-0 border-r-0 border-b border-solid border-gray-300',
    'border-l-0 h-10',
    !isOpen && 'border-none pl-0'
  );

  return (
    <div className={clearFilterClass}>
      <span
        role="button"
        tabIndex={0}
        className="clear-filters font-normal text-sm cursor-pointer whitespace-nowrap"
        onClick={clearFilters}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            clearFilters(e);
            e.preventDefault();
          }
        }}
      >
        Clear Filters
      </span>
      {closeSideMenuButtonNew({ isOpen, closeSideMenu })}
    </div>
  );
}
